import './gallery.less';

const ProductGallery = (() => {
    let thumbnails = document.getElementsByClassName('js-product-gallery-thumbnail');
    let mainPhoto = document.querySelector('#js-product-gallery-main-photo');
    
    const setActiveThumbnails = current => {
        if (!current.classList.contains('active')){
            [...thumbnails].map( thumbnail => thumbnail.classList.remove('active'));
            current.classList.add('active');
        }
        
        mainPhoto.src = current.getElementsByTagName('img')[0].dataset.src;
    };
    
    [...thumbnails].map( thumbnail => thumbnail.addEventListener('click', e => setActiveThumbnails(e.currentTarget) ));

})();


export default ProductGallery;


// WEBPACK FOOTER //
// ./components/product/gallery/gallery.js